import { render, staticRenderFns } from "./yqjxsqForm.vue?vue&type=template&id=460de8a8&scoped=true&"
import script from "./yqjxsqForm.vue?vue&type=script&lang=js&"
export * from "./yqjxsqForm.vue?vue&type=script&lang=js&"
import style0 from "./yqjxsqForm.vue?vue&type=style&index=0&id=460de8a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460de8a8",
  null
  
)

export default component.exports